<template>
    <div :class="[data && data.group_stroski && data.group_stroski.length ? 'distributor-main-table' : '']" class="w-100 overflow-auto">
        <table class="w-100 overflow-auto">
            <thead>
                <tr>
                    <th>Celoten znesek (€)</th>
                    <th>Ključ delitve</th>
                    <th>Količina</th>
                    <th>Sk. kol.</th>
                    <th>Faktor</th>
                    <th>Cena za razdelitve (€)</th>
                    <th>Osnova za DDV (€)</th>
                    <th>Stopnja DDV (%)</th>
                    <th>Znesek DDV (€)</th>
                    <th>Skupaj DDV (€)</th>
                </tr>
            </thead>
            <tbody v-if="data && data.group_stroski && data.group_stroski.length > 0">
                <template v-for="(groupedCost, index) of data.group_stroski">
                    <tr class="colored" :key="`${id}_cost_${index}`">
                        <td colspan="2">
                            Vrsta stroška
                        </td>
                        <td class="font-bold" colspan="8">
                            {{ groupedCost.strosek_sifra }} {{ groupedCost.strosek_naziv }}
                        </td>
                    </tr>
                    <template v-if="groupedCost.stroski && groupedCost.stroski.length > 0">
                        <template v-for="(item, idxCost) of groupedCost.stroski">
                            <tr :key="`${id}_cost_${item.dobavitelj_interna_stevilka}_${index}_${groupedCost.strosek_sifra}_${item.skupaj_zddv}_${idxCost}`">
                                <td class="font-bold">
                                    {{ convertFloat(item.fks_skupaj_zddv) }}
                                </td>
                                <td>{{ item.formula_naziv }}</td>
                                <td>{{ convertFloat(item.kolicina) }}</td>
                                <td>{{ convertFloat(item.fks_skupaj_zddv / item.znesek_za_enoto) }}</td>
                                <td>{{ convertFloat(item.faktor_obracun) }}</td>
                                <td>{{ convertFloat(item.znesek_za_enoto, 4) }}</td>
                                <td>{{ convertFloat(item.osnova_ddv,4) }}</td>
                                <td>{{ convertFloat(item.davcna_stopnja_procent) }}</td>
                                <td>{{ convertFloat(item.skupaj_zddv - item.osnova_ddv, 4) }}</td>
                                <td>{{ convertFloat(item.skupaj_zddv, 4) }}</td>
                            </tr>
                            <tr :key="`${id}_cost_${item.dobavitelj_interna_stevilka}_${index}_${groupedCost.strosek_sifra}_${item.skupaj_zddv}_${idxCost + 1}`">
                                <td colspan="2">
                                    Interna št: <span class="font-bold text-primary cursor-pointer" @click="openCostDialog(item)">{{ item.dobavitelj_interna_stevilka }}</span>
                                </td>
                                <td colspan="1">
                                    Št. orig. rač:
                                    <template v-if="item.dobavitelj_racuni">
                                        <div
                                            class="font-bold"
                                            :class="{'text-primary cursor-pointer': item.dobavitelj_racuni.has_document}"
                                            @click="downloadPDF(item.dobavitelj_racuni)"
                                        >
                                            {{ item.dobavitelj_dobav_stevilka }} <img  v-if="item.dobavitelj_racuni.has_document"  width="15px" height="15px" :src="require('@/assets/svg/pdf_icon.svg')" alt="pdf"/>
                                        </div>
                                    </template>
                                    <span v-else-if="item.dobavitelj_dobav_stevilka" class="font-bold">{{ item.dobavitelj_dobav_stevilka }}</span>
                                    <span v-else class="font-bold">/</span>
                                </td>
                                <td colspan="2">
                                    Datum računa: <span class="font-bold">{{ formatDate(item.datum_dokumenta) }}</span>
                                </td>
                                <td colspan="2">
                                    <span v-if="item.vrsta_stroska === '5'" class="font-bold d-block mb-2">PORABA SREDSTEV REZERVNEGA SKLADA {{ item.poraba_rs_opis_stroska }}</span>
                                    Opis: <span class="font-bold">{{ item.namen }} {{ item.namen_dodatno }}</span>
                                </td>
                                <td colspan="3">
                                    Oprema storitev: <span class="font-bold">{{ formatDate(item.datum_obdobja_od) }} - {{ formatDate(item.datum_obdobja_do) }}</span>
                                </td>
                            </tr>
                            <tr :class="{'cost-last-row': idxCost < groupedCost.stroski.length -1}" :key="`${id}_cost_${item.dobavitelj_interna_stevilka}_${index}_${groupedCost.strosek_sifra}_${item.skupaj_zddv}_${idxCost + 2}`">
                                <td colspan="2">
                                    DŠ/ID za DDV: <span class="font-bold">{{ item.dobavitelj_davcna }}</span>
                                </td>
                                <td colspan="3">
                                    Dobavitelj: <span class="font-bold">{{ item.dobavitelj_naziv }}</span>
                                </td>
                                <td colspan="5">
                                    Sedež: <span class="font-bold">{{ item.dobavitelj_naslov }}</span>
                                </td>
                            </tr>
                        </template>
                    </template>
                </template>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="10" class="text-center">
                        Ni podatkov za prikaz
                    </td>
                </tr>
            </tbody>
            <tfoot v-if="data">
                <tr>
                    <th colspan="4">
                        Skupaj za plačilo enota
                    </th>
                    <th>
                        Stroški
                    </th>
                    <th class="!font-semibold !border-t-2" colspan="3">
                        {{ convertFloat(data.osnova_ddv,4) }}
                    </th>
                    <th class="!font-semibold !border-t-2">
                        {{ convertFloat(data.znesek_ddv,4) }}
                    </th>
                    <th class="!font-semibold !border-t-2">
                        {{ convertFloat(data.skupaj_zddv,4) }}
                    </th>
                </tr>
                <tr>
                    <th colspan="4" />
                    <th class="border-t" colspan="5">
                        Poraba
                    </th>
                    <th class="border-t">
                        {{ convertFloat(data.poraba_rezervega_sklada_skupaj_zddv,4) }}
                    </th>
                </tr>
                <tr>
                    <th colspan="4" />
                    <th class="border-t" colspan="5">
                        Vse skupaj
                    </th>
                    <th class="border-t">
                        {{ convertFloat(data.vse_skupaj_zddv,4) }}
                    </th>
                </tr>
            </tfoot>
        </table>

        <BModal :visible="showCostDialog" size="lg" hide-footer @cancel="hideDialog" @hidden="hideDialog" @close="hideDialog">
            <div>
                <h3 style="font-weight: bold;">Delitev stroška</h3>
            </div>
            <div v-if="data && cost" class="custom-table overflow-auto w-100 mt-1">
                <table class="w-100 overflow-auto">
                    <thead>
                        <tr>
                            <th class="min-w-[140px]">
                                Datum od-do
                            </th>
                            <th>Strošek</th>
                            <th>Naziv stroška</th>
                            <th>Osnova DDV (€)</th>
                            <th>DDV (€)</th>
                            <th>Skupaj (€)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ formatDate(cost.datum_obdobja_od) }} - {{ formatDate(cost.datum_obdobja_do) }}</td>
                            <td>{{ cost.strosek_sifra }}</td>
                            <td>{{ cost.strosek_naziv }}</td>
                            <td>{{ convertFloat(cost.osnova_ddv) }}</td>
                            <td>{{ convertFloat(cost.skupaj_zddv - cost.osnova_ddv) }}</td>
                            <td>{{ convertFloat(cost.skupaj_zddv) }}</td>
                        </tr>
                        <tr>
                            <th colspan="5">
                                Skupaj:
                            </th>
                            <th>
                                {{ convertFloat(cost.skupaj_zddv) }}
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </BModal>
    </div>
</template>

<script>
    import {convertFloat, downloadAttachment} from '@/libs/helpers'
    import {formatDate} from '@/libs/dayjs'
    import {BModal} from 'bootstrap-vue'

    export default {
        components: {BModal},
        props: {
            data: {
                type: Object,
                default: undefined
            },
            date: {
                type: String,
                default: ''
            },
            reference: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                cost: null,
                showCostDialog: false,
                id: `${this.reference}_${Math.floor(Math.random() * 100)}`
            }
        },
        methods: {
            formatDate,
            convertFloat,
            hideDialog() {
                this.showCostDialog = false
            },
            openCostDialog(data) {
                this.cost = data
                this.showCostDialog = true
            },
            async downloadPDF(document) {
                if (!this.data || !document.has_document) return
                await downloadAttachment(this, `/api/iiportal-user/v1/attachements/file/dokumenti-dobavitelja/${this.data.enota_sifra.toLowerCase()}/${document.dokument_stevilka}`, `${document.dobavitelj_naziv}_${this.date}`, true)
            }
        }
    }
</script>

<style scoped>
.distributor-main-table th {
  border-bottom: none !important;
}

.font-bold {
  font-weight: 600;
}
</style>